import { useState } from 'react';
import { useSubscriptionContext } from '@/modules/subscriptions/context/SubscriptionProvider';

export function useUpgradePrompts() {
  const { isPremium } = useSubscriptionContext();
  const [upgradePrompt, setUpgradePrompt] = useState({
    isOpen: false,
    title: '',
    message: '',
    feature: ''
  });

  const showUpgradePrompt = (config = {}) => {
    // Only show upgrade prompt if user is not premium
    if (isPremium) return false;

    const {
      title = "Upgrade to Premium",
      message = "You've reached the limit of your current plan. Upgrade to Premium for unlimited access to all features.",
      feature = "premium feature"
    } = config;

    setUpgradePrompt({
      isOpen: true,
      title,
      message,
      feature
    });

    return true; // Indicates upgrade prompt was shown
  };

  const hideUpgradePrompt = () => {
    setUpgradePrompt(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  // Specific upgrade prompt configurations
  const promptConfigs = {
    squadLimit: {
      title: "Create More Squads",
      message: "Free users can create 1 squad. Upgrade to Premium to create unlimited squads and manage multiple teams.",
      feature: "unlimited squads"
    },
    playerLimit: {
      title: "Add More Players",
      message: "Free users can add up to 15 players per squad. Upgrade to Premium to add unlimited players.",
      feature: "unlimited players"
    },
    saveMatch: {
      title: "Save Match History",
      message: "Save your match results permanently and access detailed game statistics. Upgrade to Premium to keep all your match history.",
      feature: "match history storage"
    }
  };

  const showSquadLimitPrompt = () => showUpgradePrompt(promptConfigs.squadLimit);
  const showPlayerLimitPrompt = () => showUpgradePrompt(promptConfigs.playerLimit);
  const showSaveMatchPrompt = () => showUpgradePrompt(promptConfigs.saveMatch);

  return {
    upgradePrompt,
    showUpgradePrompt,
    hideUpgradePrompt,
    showSquadLimitPrompt,
    showPlayerLimitPrompt,
    showSaveMatchPrompt,
    isPremium
  };
}